import { isLogged } from '@/utils';

const guard = (to, from, next) => {
  const logged = isLogged();

  // check if logged
  if (logged) next();
  // check the token and if good purchase
  else if (typeof phpTokenBooker !== 'undefined') {
    /* global phpTokenBooker */
    if (phpTokenBooker !== null) {
      // check the tokenBooker in backend
      next();
    } else { next('/notFound'); }
  } else {
    next('/notFound');
  }
};

export default guard;
